import { render } from "./social_calendar.vue?vue&type=template&id=40c35aeb&scoped=true"
import script from "./social_calendar.vue?vue&type=script&lang=js"
export * from "./social_calendar.vue?vue&type=script&lang=js"

import "./social_calendar.vue?vue&type=style&index=0&id=40c35aeb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c35aeb"]])

export default __exports__